module.exports = __webpack_public_path__ + "static/img/4.fee39f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/4.png
// module id = QP6G
// module chunks = 0